import { render, staticRenderFns } from "./canales.vue?vue&type=template&id=294af2b9&scoped=true&"
import script from "./canales.vue?vue&type=script&lang=js&"
export * from "./canales.vue?vue&type=script&lang=js&"
import style0 from "./canales.vue?vue&type=style&index=0&id=294af2b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294af2b9",
  null
  
)

export default component.exports